import * as React from "react";
import {InputHTMLAttributes, ReactNode} from "react";
import {Field} from 'redux-form'
import IFormInputs from "./IFormInputs";
import {FormattedMessage} from "react-intl";
import InputRenderer from "../formrenderers/InputRenderer";
import Required from "../validations/Required";

const PostalCodeValidation: (value: any) => ReactNode | undefined =
    (value) => {
        return value && !/^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1} ?[0-9]{1}[a-zA-Z]{1}[0-9]{1}$/i.test(value)
            ? <FormattedMessage id="form.validations.postal_code.invalid" />
            : undefined;
    };

export interface IPostalCodeInputProps extends IFormInputs, InputHTMLAttributes<HTMLInputElement> {
    isRequired?: boolean;
}

export default (props: IPostalCodeInputProps) => {
    const { inputID, label = <FormattedMessage id="form.postal_code" />,
        validationDisabled = false,
        isRequired = true,
        ...rest
    } = props;


    const validations = (() => {
        if(validationDisabled) {
            return undefined;
        }

        const validations = [PostalCodeValidation];
        if(isRequired) {
            validations.push(Required);
        }
        return validations;
    })();

    return (
        <Field name={inputID} label={label} type="text" component={InputRenderer} validate={validations} {...rest} />
    );
}